export default __webpack_public_path__ + "static/media/success-alert.244d9d8a.svg";